module.exports = __webpack_public_path__ + "img/trash.85ea7d27.svg";